import React from "react";
import { useTranslation } from "react-i18next";
import {
  brandingLogoDataUrl,
  useAcquirerBrandings,
} from "../hooks/useAcquirerBrandings";

type Size = "xs" | "sm" | "md" | "lg";

interface Props {
  code?: string | null;
  size?: Size;
  showLogo?: boolean;
  showName?: boolean;
  className?: string;
  pill?: boolean;
}

const HEIGHT: Record<Size, string> = {
  xs: "h-3",
  sm: "h-4",
  md: "h-5",
  lg: "h-7",
};

const AcquirerBrand: React.FC<Props> = ({
  code,
  size = "sm",
  showLogo = true,
  showName = true,
  className = "",
  pill = false,
}) => {
  const brandings = useAcquirerBrandings();
  const { i18n } = useTranslation();

  if (!code) return <span className="text-gray-300">—</span>;

  const branding = brandings[code.toUpperCase()];
  const isArabic = i18n.language?.startsWith("ar");
  const label = branding
    ? (isArabic && branding.displayNameAr) || branding.displayName
    : code;

  const logoSrc = branding ? brandingLogoDataUrl(branding) : null;

  const base = "inline-flex flex-col items-center gap-0.5 whitespace-nowrap leading-tight px-2 py-1";
  const pillCls = pill ? "rounded-full text-gray-700" : "";
  const nameCls = branding ? "" : "font-mono text-xs";

  return (
    <span className={`${base} ${pillCls} ${className}`.trim()}>
      {showLogo && logoSrc && (
        <img
          src={logoSrc}
          alt=""
          className={`${HEIGHT[size]} w-auto object-contain`}
        />
      )}
      {showName && <span className={nameCls}>{label}</span>}
    </span>
  );
};

export default AcquirerBrand;
